import * as yup from 'yup'
export const anonymousLoginSchema = yup.object().shape({
  /* ひとまず英語にした sakao  */
  password: yup
    .string()
    .matches(/^[\d]+$/, 'number_warning')

    .min(6, 'number_warning')
    .max(6, 'number_warning')
    .required('passward_warning'),
})
